import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/parametres/confidentialite')({
  head: () => noIndexRouteHead('settingsPrivacy', 'fr'),
  component: () => <SettingsPage section="datenschutz" />,
})
